import React from 'react';
import { Link } from 'react-router-dom';
import FirmwareUpload from '../components/FirmwareUpload';
import '../App.css';

function Flat() {
  return (
    <div className="page-shell">
      <h3>直面屏</h3>
      <p>&nbsp;</p>
      <p className="page-lead">电子纸显示技术，革新信息显示方案。</p>
      <p>触摸屏功能，电子纸显示技术，是一种革新的信息显示方案。它利用电子墨水在通电时改变颜色的特性，能够像传统屏幕一样呈现图像，且可附着于塑料、纸张等多种表面。</p>
      <p>&nbsp;</p>
      <p>OTA 升级，请移至公布的新平台。</p>
      <p>&nbsp;</p>
      {/*
      <p>OTA 远程升级固件上传：</p>
      <FirmwareUpload category="flat" label="上传直面屏固件" />
      */}  
      <div className="page-actions">
        <Link to="/gallery/flat" className="link-card" title="设备列表">直面屏设备列表</Link>
      </div>
        {/*<p>日志下载，仅供内部测试：<a href="/static/log.txt" title="日志下载" target="_blank" > xxx65 端口完整日志下载</a></p> */}
    </div>
  );
}
export default Flat;